module.exports = __webpack_public_path__ + "assets/img/soldiers_6.9cd21cd9.png";